/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OccupationBranche } from './occupationBranche';
import { OccupationKind } from './occupationKind';

/**
 * (german: Berufstätigkeit)   (bipro-partner::Berufstätigkeit)
 */
export interface Employment {
  occupationKind?: OccupationKind;
  occupationBranche?: OccupationBranche;
  /**
   * In case of true, the occupation is in public service   (german: Öffentlicher Dienst).
   */
  publicService?: boolean;
}
export namespace Employment {}
